export let listData = {
	bindings: {
		activity: '<',
		selected: '<',
	},
	template: `
    <div class="col-md-12 m-v-sm">
      <div class="md-list-item-text">
      <div class="col-xs-10 col-md-10 no-padding-r">
          <p class="text-sm-important text-color no-margin exo p-v-xs {{ vm.changeColor }}">
          <i 
            ng-if="vm.activity.isStrategicTracing==1"
            ng-class="::vm.classEye"
            class="icon i-24 no-padding"
            ng-click="vm.strategicTracing(vm.details)"
            ng-disabled="vm.showEye()"><md-tooltip class="custom-tooltip" md-direction="right">Seguimiento estratégico</md-tooltip>  
          </i>
            {{ vm.headerName }}  
          </p>
          <p class="text-xs-important no-margin proxima {{ vm.changeColor }} p-v-xs">
            {{ vm.topDescription }} 
          </p>
          <p class="text-xs-important no-margin {{ vm.urgent }} p-v-xs">
            {{ vm.bottomDescription }}
         </p>
      </div>
      </div>
    </div>`,
	controllerAs: 'vm',
	controller  : [ '$state', '$cookies', '$stateParams', 'Validations', 'CssClasses', 'Ramda', 'WorkPlanSrv', '$rootScope',
		function listDataCtrl ($state, $cookies, $stateParams, Validations, CssClasses, Ramda, WorkPlanSrv, $rootScope) {
			const { curry } = Ramda
			const textColor = CssClasses.textColor
			const icons = CssClasses.icons

			const listText = (activity) => {
				return {
					dateRange         : `Inicio: ${activity.startDate} - Fin: ${activity.endDate}`,
					asignatureCode    : `COD${activity.asignatureCode || ' NA'}`,
					periodicity       : activity.periodicityName || 'No hay períodos planeados en esta actividad',
					plannedHours      : `${activity.totalHoursPlanned || 0} hrs. planeadas - ${activity.totalHoursExecuted || 0} hrs. ejecutadas`,
					totalPlannedHours : `Total hrs planeada: ${activity.totalHoursPlanned || 0} - Total hrs ejecutadas: ${activity.totalHoursExecuted || 0}`,
					totalExecutedHours: `hrs ejecutadas: ${activity.totalHoursExecuted || 0}`,
					percentage        : `Porcentaje ${activity.percentageDedication || 0}%`,
					unit              : `${activity.academicUnitName || 'Sin unidad académica asignada'}`,
					plannedPercentage : `Porcentaje planeado: ${activity.percentagePanning || 0}%`,
					executedPercentage: `Porcentaje ejecutado: ${activity.percentageExecuted || 0}%`,
					nameRegister      : `${activity.nameCommunicationRegister || 'No posee registro'}`,
				}
			}

			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
			const inReviewExecution = Validations.inReviewExecution(currentStage)
			const inEvaluation = Validations.inEvaluation(currentStage)

			this.headerName = ''
			this.topDescription = ''
			this.bottomDescription = ''
			const {
				isActivitiesType,
				isCommitteeParticipationType,
				isSubjectType,
				isPositionByDelegationType,
				isStudentAttentionType,
				isOtherActivitiesType,
				isRolesType,
				isCrossExtensionProjectsType,
				isVisibilityType,
			} = Validations

			this.$onInit = () => {
				this.urgent = isUrgent() ? textColor.red : setTextColor(this)
				setTextColor(this)
			}

			this.$onChanges = () => {
				this.urgent = isUrgent() ? textColor.red : setTextColor(this)
				setTextColor(this)
				this.headerName = getHeaderName(this.activity)
				this.topDescription = getTopDescription(this.activity)
				this.bottomDescription = getBottomDescription(this.activity)
			}

			function setTextColor (scope) {
				scope.changeColor = scope.selected === scope.activity ? textColor.white : textColor.black

				return scope.changeColor
			}

			function isUrgent () {
				return inEvaluation || inReviewExecution
			}
      
			$rootScope.$on('rootScope:execHours', () => {
				this.headerName = getHeaderName(this.activity)
				this.topDescription = getTopDescription(this.activity)
				this.bottomDescription = getBottomDescription(this.activity)
			})
			function getHeaderName(activity) {
				switch (true) {

				case isSubjectType(activity):
					return activity.asignatureName || 'Actividad de sin nombre asignado'
				case isActivitiesType(activity):
					return activity.activityTypeNameCombo || 'Actividad de sin nombre asignado'
				case isStudentAttentionType(activity):
					return activity.scheduleTypeName || 'Actividad de sin nombre asignado'
				case isPositionByDelegationType(activity):
					return activity.workplanTeacherChargeName || 'Cargo por delegación sin nombre'
				case isCommitteeParticipationType(activity):
					return activity.committeeName || 'Actividad de sin nombre asignado'
				case isRolesType(activity):
					return activity.roleName || 'Actividad de sin nombre asignado'
				case isOtherActivitiesType(activity):
					return activity.otherActivityItemName || 'Actividad de sin nombre asignado'
				case isCrossExtensionProjectsType(activity):
					return activity.projectName || 'Actividad de sin nombre asignado'
				default:
					return activity.name || 'Actividad de sin nombre asignado'
      
				}
			}
			function getTopDescription(activity) {
				let list = listText(activity)

				switch (true) {

				case isSubjectType(activity):
					return [ list.asignatureCode, list.periodicity, list.totalPlannedHours ].join(' - ')
				case isActivitiesType(activity):
					return list.plannedHours
				case isStudentAttentionType(activity):
					return list.plannedHours
				case isPositionByDelegationType(activity):
					return list.unit
				case isCommitteeParticipationType(activity):
					return isUrgent() ? '' : list.totalPlannedHours
				case isRolesType(activity):
					return isUrgent() ? '' : [ activity.startDate ? list.dateRange : list.periodicity, list.unit ].join(' - ')
				case isOtherActivitiesType(activity):
					return isUrgent() ? '' : [ activity.startDate ? list.dateRange : list.periodicity, list.plannedHours ].join(' - ')
				default:
					return isUrgent() ? '' : list.totalPlannedHours
      
				}
			}
			function getBottomDescription(activity) {
				let list = listText(activity)
				let text = ''

				switch (true) {

				case isPositionByDelegationType(activity):
					text = isUrgent() ? [ list.plannedPercentage, list.executedPercentage ] : [ list.totalPlannedHours, list.percentage ]
					break
				case isRolesType(activity):
					text = isUrgent() ? [ list.totalPlannedHours ] : [ list.totalPlannedHours || 'No registra planeación' ]
					break
				case isVisibilityType(activity):
					text = isUrgent() ? [ list.totalPlannedHours ] : [ list.nameRegister ]
					break
				case isSubjectType(activity) || isActivitiesType(activity) || isStudentAttentionType(activity):
					text = [ '' ]
					break
				default:
					text = isUrgent() ? [ list.totalPlannedHours ] : [ '' ]
					break
      
				}

				if (text !== [ '' ]) {
					text = text.filter(Boolean)

					return text.join(' - ')
				} else {
					text = text.filter(Boolean)
				}
			}

			angular.extend(this, {
				urgent       : '',
				changeColor  : '',
				classEye     : [ icons.eye, textColor.green ],
				approvedHand : [ icons.thumbsUp, textColor.blue ],
				repprovedHand: [ icons.thumbsDown, textColor.blue ],
			})
		},
	] }



// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activities-list/list-data.js